export const getDirectMediaUrlInputValue = (value) => {
  const mediaUrl = String(value || '');
  return mediaUrl.startsWith('/') ? '' : mediaUrl;
};
